import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/App/App';
import './util/fontAwesome';
import './index.scss';
import "./assets/robots.txt";


const startApp = () => {
  ReactDOM.render((
    <App />
  ), document.getElementById('app'));
};

if (window.cordova) {
  document.addEventListener('deviceready', () => {
    startApp();
    setTimeout(() => {
      window.navigator.splashscreen.hide();
      window.StatusBar.backgroundColorByHexString('#ECEFF1');
      window.StatusBar.styleDefault();
    }, 1000);
  }, false);
} else {
  startApp();
}
